import { PropsWithChildren } from 'react';
import { useUserSelfDetails } from '@steelbuy/data-access';
import { LoadingSpinner } from '@steelbuy/ui-primitive';

export const LoadSelfUser = ({ children, showSpinner = true }: PropsWithChildren & { showSpinner?: boolean }) => {
    const { isLoading } = useUserSelfDetails({ queryOptions: { enabled: true } });

    return isLoading && showSpinner ? <LoadingSpinner /> : children;
};
